import { Link } from "react-router-dom";

/**
 * Orixa Invest — official brand mark.
 *
 * Variants:
 *  - "symbol"   compass only (square), default 32px
 *  - "wordmark" compass + horizontal ORIXA INVEST wordmark (header/sidebar default)
 *  - "lockup"   full vertical lockup (auth/landing hero)
 *
 * Dark mode: swaps to the white-silhouette variant when `.dark` is on <html>.
 *
 * Pass `as="link"` (default) to wrap in a <Link to="/">, or `as="div"` for static.
 */
function SymbolImgs({ px }) {
  return (
    <span
      className="relative shrink-0 inline-block"
      style={{ width: px, height: px }}
      aria-hidden="true"
    >
      <img
        src="/brand/orixa-symbol-192.png"
        alt=""
        width={px}
        height={px}
        className="orixa-logo-light absolute inset-0 w-full h-full object-contain"
        draggable={false}
      />
      <img
        src="/brand/orixa-symbol-dark.png"
        alt=""
        width={px}
        height={px}
        className="orixa-logo-dark absolute inset-0 w-full h-full object-contain"
        draggable={false}
      />
    </span>
  );
}

export default function Logo({
  variant = "wordmark",
  size = 32,
  className = "",
  to = "/",
  as = "link",
  alt = "Orixa Invest",
  testId,
}) {
  const wrapperClass = `inline-flex items-center gap-2.5 ${className}`;

  let inner;
  if (variant === "symbol") {
    inner = (
      <>
        <span className="sr-only">{alt}</span>
        <SymbolImgs px={size} />
      </>
    );
  } else if (variant === "lockup") {
    inner = (
      <span className="relative inline-block" style={{ height: size }}>
        <img
          src="/brand/orixa-logo-lockup.png"
          alt={alt}
          className="orixa-logo-light object-contain block"
          style={{ height: size, width: "auto" }}
          draggable={false}
        />
        <img
          src="/brand/orixa-logo-lockup-dark.png"
          alt={alt}
          className="orixa-logo-dark absolute inset-0 object-contain"
          style={{ height: size, width: "auto" }}
          draggable={false}
        />
      </span>
    );
  } else {
    // "wordmark" default — compass + horizontal text lockup
    inner = (
      <>
        <SymbolImgs px={size} />
        <span className="flex flex-col leading-none">
          <span
            className="font-display tracking-[0.18em] text-foreground"
            style={{ fontSize: Math.max(13, size * 0.5) }}
          >
            ORIXA
          </span>
          <span
            className="text-muted-foreground font-semibold uppercase tracking-[0.22em] mt-1"
            style={{ fontSize: Math.max(8, size * 0.28) }}
          >
            INVEST
          </span>
        </span>
      </>
    );
  }

  if (as === "link") {
    return (
      <Link to={to} className={wrapperClass} data-testid={testId} aria-label={alt}>
        {inner}
      </Link>
    );
  }
  return (
    <div className={wrapperClass} data-testid={testId}>
      {inner}
    </div>
  );
}
